import React from 'react';
import { Carousel } from 'antd';

const debutImageContext = require.context(
  '../../../../Assets/Linkages/SpaceOutreachFilm/InternationalDebut2026',
  false,
  /\.jpg$/i,
);

const debutImages = debutImageContext.keys().sort().map((key) => {
  const image = debutImageContext(key);
  return image.default || image;
});

const InternationalDebut2026 = () => (
  <section className="film-international-debut" aria-labelledby="film-international-debut-title">
    <div className="film-international-debut-inner">
      <div className="film-international-debut-copy">
        <p className="section-eyebrow">BANGLADESH · 15–16 APRIL 2026</p>
        <h2 id="film-international-debut-title">
          International Debut: Pakistan’s First Space-Driven Climate Telefilm
        </h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          The Strategic Science Communication Training for OIC Countries: Building Bridges Between
          Scientists and Journalists for Knowledge and Advancements in Bangladesh, held in Gazipur,
          Bangladesh from 15–16 April 2026, featured a powerful highlight—the international screening
          of Pakistan’s first space-driven climate telefilm, Jahan Aur Bhi Hain — Beyond the Blue
          (JABH). Screened before more than 40 participants from 15 countries, particularly from
          Africa and Bangladesh, the telefilm uniquely delivers complex scientific concepts through
          compelling storytelling, portraying the looming threat of cloudbursts and environmental
          crises while showcasing the crucial role of space science and technology in prediction and resilience.
        </p>
        <p>
          Presented by NCGSA in collaboration with COMSTECH, the screening exemplified cinematic
          science communication at its finest, turning awareness into action across the OIC region.
        </p>
      </div>

      <Carousel
        className="film-international-debut-carousel"
        autoplay
        autoplaySpeed={3000}
        pauseOnHover
        dots
        effect="fade"
      >
        {debutImages.map((src, index) => (
          <figure key={src}>
            <img src={src} alt={`International screening in Bangladesh ${index + 1}`} loading="lazy" />
          </figure>
        ))}
      </Carousel>
    </div>
  </section>
);

export default InternationalDebut2026;
